import app from '@/AppData'

function getCallList () {
  var list = {
    'isFinished': true,
    'recordList': [],
    'result': 0,
    'totalRecord': 0,
    'totalTime': 0,
  }

  for (var val in exampleList) {
    if (app.getLocalStorage('del' + val) == 'true') {

    } else {
      list.recordList.push(exampleList[val])
      list.totalRecord = list.recordList.length
    }
  }
  return list
}

function delRecord (item) {
  app.putLocalStorage('del' + item.callKey.callerPhoneNum, 'true')
}

function getRecordByNum (num) {
  return exampleList[num]
}

const exampleList = {
  '186****240': {
    'callKey': {
      'callerPhoneNum': '186****240',
      'calledPhoneNum': '186****240'
    },
    'startTime': 1572320843,
    'endTime': 1572320887,
    'startTimeText': '09月24日 09:33',
    'endTimeText': '09月24日 09:34',
    'recordUrl': 'https://yycdn-75403.gzc.vod.tencent-cloud.com/Real_Estate_Agents_Sample_CDR.wav',
    'mark': {
      'tagType': 51
    },
    'isexample': true,
    'contactInfo': {
      'name': '智能接听助理示例',
      'location': '广州',
      'operator': '广州联通'
    },
    'firstMsg': '你好，广州花都新开了一个楼盘，首付50万起，有兴趣了解下么？',
    'chatList': [
      {
        'time': 1572320843,
        'callerText': '',
        'respText': '您好，我是Ta的助理，Ta现在正忙，不方便接电话，请问您是哪位？有什么事吗？'
      },
      {
        'time': 1572320847,
        'callerText': '你好，我们最近有一个新楼在售卖，请问您这边有兴趣吗',
        'respText': '小区具体是在哪个位置呢？'
      },
      {
        'time': 1572320860,
        'callerText': '房子是在越秀区烈士陵园附近的北横街小区，地段是很好的',
        'respText': '房子的面积有多大？'
      },
      {
        'time': 1572320870,
        'callerText': '房子面积有118平左右，3房一厅',
        'respText': '价格上有什么优惠吗？'
      },
      {
        'time': 1572320887,
        'callerText': '我们公司最近有搞优惠活动，新业主可享受3万购房优惠券',
        'respText': '嗯嗯好的，后面有需要再联系您，这边还有点事，先挂了，再见。'
      }
    ],
  },
  '186****241': {
    'callKey': {
      'callerPhoneNum': '186****241',
      'calledPhoneNum': '186****241'
    },
    'startTime': 1572320843,
    'endTime': 1572320887,
    'startTimeText': '09月24日 09:33',
    'endTimeText': '09月24日 09:34',
    'recordUrl': 'https://yycdn-75403.gzc.vod.tencent-cloud.com/Express_Delivery_Sample_CDR.wav',
    'mark': {
      'tagType': 55
    },
    'isexample': true,
    'contactInfo': {
      'name': '智能接听助理示例',
      'location': '广州',
      'operator': '广州联通'
    },
    'firstMsg': '你好，顺丰快递，你的快递到了',
    'chatList': [
      {
        'time': 1572320843,
        'callerText': '',
        'respText': '您好，我是Ta的助理，Ta现在正忙，不方便接电话，请问您是哪位？有什么事吗？'
      },
      {
        'time': 1572320847,
        'callerText': '你好，你的快递到了，请问你在家吗',
        'respText': '你好，请问是什么快递'
      },
      {
        'time': 1572320860,
        'callerText': '是顺丰快递',
        'respText': '好的，你放在小区附近的快递箱里面就可以了'
      },
      {
        'time': 1572320870,
        'callerText': '那我给你放到小区的丰巢快递箱里面了，到时候你过来拿',
        'respText': '好的，请问还有其他事情吗'
      },
      {
        'time': 1572320887,
        'callerText': '没有了',
        'respText': '好的，谢谢'
      }
    ],
  }
}

export default {
  getCallList,
  getRecordByNum,
  delRecord
}



// WEBPACK FOOTER //
// ./src/utils/exampleCallList.js